/**
 * Parquet 읽기 seam 의 공개 계약 — `hyparquet` 을 아는 파일은 이 디렉터리 안에만 있다(규칙 §9).
 *
 * 점검 artifact 의 배열은 Parquet 이다. JSON 이 아닌 이유는 큰 정수 ns 의 끝자리와 NaN 을
 * 잃지 않기 위해서다 — 그래서 이 경계는 **dtype 을 접지 않는다**. int64 는 `bigint` 로
 * 그대로 나가고 소비자가 원점을 정수로 뺀 뒤 초로 바꾼다.
 *
 * 엔진이 쓰는 표는 언제나 `value` 컬럼 하나다(스칼라 `[n]` 또는 리스트 `[n][dim]`).
 */

/** 컬럼 하나의 값 — 파일이 실제로 든 종류를 그대로 말한다. */
export type ParquetColumn =
  | { kind: "number"; rows: readonly number[] }
  | { kind: "bigint"; rows: readonly bigint[] }
  | { kind: "boolean"; rows: readonly boolean[] }
  | { kind: "numberList"; rows: readonly (readonly number[])[] };

/**
 * 파일을 읽을 수 없거나 계약(단일 `value` 컬럼)과 다를 때.
 *
 * `cause` 는 직접 든다 — `lib` 이 ES2020 이라 `Error` 의 두 번째 인자를 쓸 수 없다.
 */
export class ParquetReadError extends Error {
  readonly cause: unknown;

  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = "ParquetReadError";
    this.cause = cause;
  }
}
